import {Box, Grid, Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {Body} from 'src/shared/components/Body/Body'

import courier from './assets/courier-info.png'
import {courierInfo} from './consts'
import * as classes from './CourierInfo.classes'

export function CourierInfo() {
  return (
    <Body
      tail={
        <Grid className={classes.info} justify="flex-end" item>
          <Grid item>
            {courierInfo.map(({title, caption}, index) => (
              <Grid key={`courier-info-${index}`} alignItems="center" container>
                <Box className={classes.numbers} p="s">
                  <Typography pl="xs" pr="xs" thickness="regular" variant="body1">
                    {index + 1}
                  </Typography>
                </Box>
                <Grid className={classes.point}>
                  <Typography group="tight" thickness="regular" variant="body2">
                    {title}
                  </Typography>
                  <Typography color="minor" group="tight" variant="caption1">
                    {caption}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      }
    >
      <Grid wrap="nowrap" container>
        <Grid item xs>
          <img alt="" height={112} src={courier} srcSet={`${courier} 2x, ${courier} 3x`} width="auto" />
        </Grid>
      </Grid>
    </Body>
  )
}
